module.exports = __webpack_public_path__ + "img/0609ADD3-2804-47E9-AE33-DECEAA63F694.04f54d19.png";